import {
  IRoutingPlan,
  IRoutingPlanVersion,
  IRoutingPlanVersionsList,
  ISupplierOrrering,
} from "../types/routingPlanes";
import { toDisplayFormat } from "../../../../lib/utils/formatDate";
import { AnyObject } from "../../../../lib/interfaces";

const getConcatValues = (path, name) => {
  let result = "";
  if (path) {
    result = path;
  }
  if (name) {
    if (result) {
      result = `${result} - `;
    }
    result = `${result}${name}`;
  }
  return result;
};

export const mapRoutingPlan = (data: AnyObject) => {
  let currentProportionGroup = -1;
  const routingPlan: IRoutingPlan = {
    id: data?.tcOfferingItem?.id,
    key: data?.tcOfferingItem?.id,
    destinationId: data?.tcOfferingItem?.destination?.id,
    destination: getConcatValues(
      data?.tcOfferingItem?.destination?.path,
      data?.tcOfferingItem?.destination?.name
    ),
    abbrev: getConcatValues(
      data?.tcOfferingItem?.destination?.shortPath,
      data?.tcOfferingItem?.destination?.shortName
    ),
    offeringName: data?.tcOfferingItem?.offeringName,
    categoryId: data?.tcOfferingItem?.destination?.categoryId,
    fromDate: data?.fromDate ? `${toDisplayFormat(data.fromDate)}` : "",
    toDate: data?.toDate ? `${toDisplayFormat(data?.toDate)}` : "",
    datePeriod:
      data?.fromDate && data?.toDate
        ? `${toDisplayFormat(data?.fromDate)} - ${toDisplayFormat(data?.toDate)}`
        : "",
    tcOfferingItemId: data?.tcOfferingItem?.id,
    routingItems:
      data?.routingItems?.map((elem, idx) => {
        let proportionRatio = elem?.proportionRatio;
        if (idx === 0) {
          currentProportionGroup = elem.proportionGroup;
        } else if (elem.proportionGroup === currentProportionGroup) {
          proportionRatio = undefined;
        }

        return {
          proportionGroup: elem?.proportionGroup,
          proportionRatio,
          organization: elem?.offering?.agreement?.account?.organization?.fullName,
          offeringName: elem?.toOffering?.name || "",
          rateMax: elem?.rateMax,
          currencyId: elem?.toOffering?.currencyId,
          currencyName: "",
          key: idx,
        };
      }) || [],
    isOpenDetails: false,
    isOpenVersions: false,
  };
  return routingPlan;
};

export const mapRoutingPlanList = (data: any) => {
  if (Array.isArray(data?.content)) {
    const routingPlanesList: IRoutingPlan[] =
      data?.content?.map((item) => {
        return mapRoutingPlan(item);
      }) || [];

    return routingPlanesList;
  }
  return [];
};

const getDateSupplierOffering = (item: any, attribute: string) => {
  if (Array.isArray(item?.rateRuleItems) && item.rateRuleItems[0]) {
    return item.rateRuleItems[0][attribute]
      ? toDisplayFormat(item.rateRuleItems[0][attribute])
      : "";
  }
  return "";
};

export const mapSupplierOffering = (data: any) => {
  if (Array.isArray(data?.supplierOfferings)) {
    const supplierOrreringList: ISupplierOrrering[] = data.supplierOfferings.map((item, idx) => {
      return {
        organization: item?.offering?.agreement?.account?.organization?.fullName || "",
        toDestinationsCount: item?.toDestinationsCount || 0,
        shortOrganization: item?.offering?.agreement?.account?.organization?.shortName || "",
        offeringName: item?.offering?.name || "",
        fromDate: getDateSupplierOffering(item, "fromDate"),
        toDate: getDateSupplierOffering(item, "toDate"),
        datePeriod: `${getDateSupplierOffering(item, "fromDate")} - ${getDateSupplierOffering(
          item,
          "toDate"
        )}`,
        rateNext: item?.rateNext,
        cost: item?.rateMax,
        rateMax: Number(item?.toDestinationsCount) > 1 ? item?.rateMax : undefined,
        rateMin: Number(item?.toDestinationsCount) > 1 ? item?.rateMin : undefined,
        key: idx,
        id: item?.offering?.id,
      };
    });
    return supplierOrreringList;
  }
  return [];
};

export const mapRoutingPlanVersions = (action: AnyObject) => {
  const _routingPlansVersions: IRoutingPlanVersionsList[] = [];
  const _versionList: IRoutingPlanVersion[] = [];

  let currentProportionGroup = -1;

  Array.isArray(action.payload) &&
    action.payload.forEach((item) => {
      const _routingOrdersVersion: IRoutingPlanVersion = {
        id: item?.id,
        tcOfferingItemId: item?.tcOfferingItemId,
        key: item?.id,
        destination: getConcatValues(
          item?.tcOfferingItem?.destination?.path,
          item?.tcOfferingItem?.destination?.name
        ),
        abbrev: getConcatValues(
          item?.tcOfferingItem?.destination?.shortPath,
          item?.tcOfferingItem?.destination?.shortName
        ),
        fromDate: item?.fromDate ? `${toDisplayFormat(item.fromDate)}` : "",
        toDate: item?.toDate ? `${toDisplayFormat(item?.toDate)}` : "",
        datePeriod: `${toDisplayFormat(item?.fromDate)} - ${toDisplayFormat(item?.toDate)}`,
        categoryId: item?.tcOfferingItem?.destination?.categoryId,
        offeringName: item?.tcOfferingItem?.offeringName,
        routingItems:
          item?.routingItems?.map((elem, idx) => {
            let proportionRatio = elem?.proportionRatio;
            if (idx === 0) {
              currentProportionGroup = elem.proportionGroup;
            } else if (elem.proportionGroup === currentProportionGroup) {
              proportionRatio = undefined;
            }

            return {
              proportionGroup: elem?.proportionGroup,
              proportionRatio,
              organization: elem?.offering?.agreement?.account?.organization?.fullName,
              offeringName: elem?.toOffering?.name || "",
              rateMax: elem?.rateMax,
              currencyId: elem?.toOffering?.currencyId,
              currencyName: "",
              key: idx,
            };
          }) || [],
        isOpenDetails: false,
      };
      _versionList.push(_routingOrdersVersion);
    });

  _routingPlansVersions.push({
    id: action.meta.arg.tcOfferingItemId,
    list: _versionList,
  });
  return _routingPlansVersions;
};

export const mapRoutingPlanVersionList = (data: any) => {
  if (Array.isArray(data?.content)) {
    const routingPlanesList: IRoutingPlan[] =
      data?.content?.map((item) => {
        return mapRoutingPlanVersions(item);
      }) || [];

    return routingPlanesList;
  }
  return [];
};
